"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");

var LRUCache = require("lru-cache");

var MediatedQuadSource_1 = require("./MediatedQuadSource");
/**
 * A comunica Hypermedia RDF Resolve Quad Pattern Actor.
 */


var ActorRdfResolveQuadPatternHypermedia =
/*#__PURE__*/
function (_bus_rdf_resolve_quad) {
  _inherits(ActorRdfResolveQuadPatternHypermedia, _bus_rdf_resolve_quad);

  function ActorRdfResolveQuadPatternHypermedia(args) {
    var _this;

    _classCallCheck(this, ActorRdfResolveQuadPatternHypermedia);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfResolveQuadPatternHypermedia).call(this, args));
    _this.cache = _this.cacheSize ? new LRUCache({
      max: _this.cacheSize
    }) : null;

    if (_this.cache) {
      _this.httpInvalidator.addInvalidateListener(function (_ref) {
        var url = _ref.url;
        return url ? _this.cache.del(url) : _this.cache.reset();
      });
    }

    return _this;
  }

  _createClass(ActorRdfResolveQuadPatternHypermedia, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var sources;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sources = this.hasContextSingleSource(action.context);

                if (sources) {
                  _context.next = 3;
                  break;
                }

                throw new Error('Actor ' + this.name + ' can only resolve quad pattern queries against a single source.');

              case 3:
                return _context.abrupt("return", true);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "getSource",
    value: function getSource(context, operation) {
      var contextSource = this.getContextSource(context);
      var url = this.getContextSourceUrl(contextSource);
      var source; // Try to read from cache

      if (this.cacheSize && this.cache.has(url)) {
        source = this.cache.get(url);
      } else {
        // If not in cache, create a new source
        source = new MediatedQuadSource_1.MediatedQuadSource(this.cacheSize, context, url, bus_rdf_resolve_quad_pattern_1.getDataSourceType(contextSource), {
          mediatorMetadata: this.mediatorMetadata,
          mediatorMetadataExtract: this.mediatorMetadataExtract,
          mediatorRdfDereference: this.mediatorRdfDereference,
          mediatorRdfResolveHypermedia: this.mediatorRdfResolveHypermedia,
          mediatorRdfResolveHypermediaLinks: this.mediatorRdfResolveHypermediaLinks
        }); // Set in cache

        if (this.cacheSize) {
          this.cache.set(url, source);
        }
      }

      return Promise.resolve(source);
    }
  }]);

  return ActorRdfResolveQuadPatternHypermedia;
}(bus_rdf_resolve_quad_pattern_1.ActorRdfResolveQuadPatternSource);

exports.ActorRdfResolveQuadPatternHypermedia = ActorRdfResolveQuadPatternHypermedia;